export default {
    title: 'Create new trend radar',
    form: {
        title: 'Trend radar title',
        description: 'trend radar description',
        cancel: 'Cancel',
        submit: 'Create trend radar',
        errors: {
            title: 'Please enter a title',
            criteriaSetId: 'Please select a criteria set'
        }
    }
}
